import { pageSelectorGenerator } from '@test/pageSelectors';

export const ExternalCheckoutInstructionsSelectors = pageSelectorGenerator('ExternalCheckoutInstructions', ['ContainerElement', 'GotItButton']);
